import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/httpService';
import { StorageService } from '../services/StorageService';

@Component({
  selector: 'app-enterprise-decks',
  templateUrl: './enterprise-decks.component.html',
})
export class EnterpriseDecksComponent {


  general: boolean = false;
  specific: boolean = false;
  source = "";
  blogs = [];
  loading: boolean = false;
  ipAddress; os; owner; meetingLink;
  constructor(public router: Router, private httpService: HttpService, private activeRoute: ActivatedRoute, private localStorage: StorageService) {

    this.source = decodeURI(this.activeRoute.snapshot.params['id']);
    this.owner = decodeURI(this.activeRoute.snapshot.params['owner']);

    this.ipAddress = this.localStorage.get("IpAddress") || '';

    this.os = this.getMobileOperatingSystem();

    if (this.owner == "df") { this.meetingLink = "https://calendly.com/df-cabbagepay/30min" }
    if (this.owner == "pk") { this.meetingLink = "https://calendly.com/pk-cabbagepay/30min" }


    //this.fetchOneBlog(this.source);

    if (this.source != "undefined") {
      this.fetchOneBlog();

      this.specific = true;


    }
    else {
      this.general = true;

    }



    this.loading = true;

    setTimeout(function () {
      this.loading = false;

    }, 3000);





  }




  blog;

  fetchOneBlog() {

    this.loading = true;


    const request = {
      route: this.source,
      ipAddress: this.ipAddress,
      device: this.os
    }

    this.httpService.post<any>('Store/fetch-specific-enterprise-deck', request, false).subscribe(
      resp => {
        this.blog = JSON.parse(resp.message);

        console.log(this.blog);


        setTimeout(function () {
          this.loading = false;

        }, 3000);


      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }


  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent;

    if (userAgent.toUpperCase().indexOf('ANDROID') > 0) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710

    if (userAgent.toUpperCase().indexOf('IPAD') > 0 || userAgent.toUpperCase().indexOf('IPHONE') > 0 || userAgent.toUpperCase().indexOf('IPOD') > 0) {
      return "iOS";
    }

    return "unknown";

  }


}
